import React from "react"
import PropTypes from "prop-types"
import Radium from "higher-order-components/configured-radium/"

/**
 * Animated Arrow component.
 * @param {Number} [scale = 1] - Scale of the arrow
 * @param {String} [bgColor = '#f5f5f5'] - Arrow background colour
 * @param {String} [borderColor = '#e7e7e7'] - Arrow border colour
 * @param {Boolean} [down = false] - Direction in which the arrow points. Points up by default.
 * @param {Number} [leftPx] - Position from left in px
 * @param {Number} [leftPercent] - Position from left in percent
 * @returns {ReactElement} React Component
 */
const AnimatedArrow = ({
  scale = 1,
  bgColor = "#f5f5f5",
  borderColor = "#e7e7e7",
  down = false,
  leftPx,
  leftPercent
}) => (
  <div
    style={[
      {
        position: "relative",
        overflow: "hidden",
        boxSizing: "border-box",
        height: `${scale * Math.sqrt(2) / 2}em`
      },
      down ? { top: "-1px" } : { bottom: "-1px" }
    ]}>
    <div
      style={[
        {
          position: "absolute",
          zIndex: 1,
          transition: ".5s",
          left: leftPx ? leftPx + "px" : leftPercent + "%"
        },
        down
          ? { transform: "translate(-50%, -50%)", top: "-1px" }
          : { transform: "translate(-50%, 50%)", bottom: "-1px" }
      ]}>
      <div
        style={{
          height: `${scale}em`,
          width: `${scale}em`,
          border: `1px solid ${borderColor}`,
          transform: "rotate(45deg)",
          background: bgColor
        }} />
    </div>
  </div>
)

AnimatedArrow.propTypes = {
  leftPx: PropTypes.number,
  leftPercent: PropTypes.number,
  borderColor: PropTypes.string,
  bgColor: PropTypes.string,
  scale: PropTypes.number,
  down: PropTypes.bool
}

export default Radium(AnimatedArrow)



// WEBPACK FOOTER //
// ./src/containers/animated-arrow/index.jsx